<template>
    <div class="code-wrapper">
        <button :class="{success: showSuccess}" class="to-clipboard" @click="copyToClipboard" :title="texts.misc.copyToClipboard" :aria-label="texts.misc.copyToClipboard"></button>
        <pre v-highlightjs><code class="html javascript"><slot></slot></code></pre>
    </div>
</template>

<script>
import Vue from "vue";
import hljs from "highlight.js";

Vue.directive("highlightjs", {
  deep: true,
  bind: function(el, binding) {
    // instead of the element content.
    // on first bind, highlight all targets
    let targets = el.querySelectorAll("code");
    targets.forEach(target => {
      // if a value is directly assigned to the directive, use this
      if (binding.value) {
        target.textContent = binding.value;
      }
      hljs.highlightBlock(target);
    });
  },
  componentUpdated: function(el, binding) {
    // after an update, re-fill the content and then highlight
    let targets = el.querySelectorAll("code");
    targets.forEach(target => {
      if (binding.value) {
        target.textContent = binding.value;
        hljs.highlightBlock(target);
      }
    });
  }
});

export default {
  name: "CodeBlock",
  data() {
    return {
      showSuccess: false
    };
  },
  props:{
    dataTracking: String
  },
  methods: {
    copyToClipboard(e) {
      const el = e.target.parentNode.getElementsByTagName("pre")[0];
      const text = el.innerText;
      const targetEl = document.createElement("textarea");
      targetEl.value = text;
      targetEl.setAttribute("readonly", "");
      targetEl.style.position = "absolute";
      targetEl.style.left = "-9999px";
      document.body.appendChild(targetEl);
      targetEl.select();
      document.execCommand("copy");
      document.body.removeChild(targetEl);
      this.showSuccess = true;
      setTimeout(
        function() {
          this.showSuccess = false;
        }.bind(this),
        1500
      );
      this.dispatchEvent();
    },
    dispatchEvent(){
        var e;
        if (window.CustomEvent) {
          e = new CustomEvent("codeblock-copy");
        } else {
          e = document.createEvent('CustomEvent');
          e.initCustomEvent("codeblock-copy", true, true);
        }
        e["codeType"] = this.dataTracking;
        window.dispatchEvent(e);
    }
  }
};
</script>


<style>
.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em;
  background: #272822;
  color: #f8f8f2;
}

.hljs-name {
  color: #f92672;
  font-weight: bold;
}

.hljs-keyword {
  font-weight: bold;
  color: #66d9ef;
}

.hljs-string {
  color: #a6e22e;
}

.hljs-literal,
.hljs-number,
.hljs-attr {
  color: #ae81ff;
}

.hljs-comment {
  color: slategray;
}

pre,
pre * {
  font-family: monospace;
}

.code-wrapper {
  position: relative;
}

.code-wrapper button.to-clipboard {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  background-color: transparent;
  background: url("../assets/outline-file_copy-24px-white.svg");
  background-repeat: no-repeat;
  height: 24px;
  width: 24px;
  border: none;
  cursor: pointer;
  transition: all .3s ease-in-out;
}

.code-wrapper button.to-clipboard:hover {
  background: url("../assets/baseline-file_copy-24px-white.svg");
  background-repeat: no-repeat;
}

.code-wrapper button.to-clipboard.success {
  background: url("../assets/fill-check-circle-24px-white.svg");
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/CodeBlock.vue